import DropdownCommon, {
  DropdownItemStyled,
} from 'components/common/DropdownCommon';
import ArrowDownIcon from 'components/common/Icons/ArrowDownIcon';
import { Fade } from 'helpers/animation';
import mask from 'helpers/mask';
import { useDetectDevice } from 'hooks/useDetectDevice';
import useLang from 'hooks/useLang';
import useStore from 'hooks/useStore';
import React, { useState } from 'react';
import styled from 'styled-components';
import {
  fontSize14Mixin,
  paragraph500Mixin,
  textEllipsisFirstLineMixin,
} from 'styles';
import CustomResendViaPopup from './mobile';

const CustomResendViaDropdown = ({
  text,
  textStyles = {},
  onResendViaEmail = () => {},
  onResendViaMobile = () => {},
  styleDropdown = {},
  styleDropdownToggle = {},
  styleDropdownMenu = {},
}) => {
  const { t } = useLang();
  const { state } = useStore();
  const { currentUser } = state;
  const { isDesktop } = useDetectDevice();

  const [isShowDropdown, setShowDropdown] = useState(false);

  let { mobile, email } = currentUser || {};

  const RESEND_ACTIONS = [
    { label: 'SMS', desc: mask.phone(mobile) },
    { label: 'EMAIL', desc: mask.email(email) },
  ];

  const handleResendViaMobile = () => {
    if (onResendViaMobile) {
      onResendViaMobile();
      setShowDropdown(false);
      return;
    }

    setShowDropdown(false);
  };

  const handleResendViaEmail = () => {
    if (onResendViaEmail) {
      setShowDropdown(false);
      onResendViaEmail();
      return;
    }

    setShowDropdown(false);
  };

  const handleDropdownOnToggle = () => {
    setShowDropdown(!isShowDropdown);
  };

  const renderDropdownToggleChildren = () => (
    <>
      {text && <ActionText style={textStyles}>{text}</ActionText>}
      <ArrowDownIcon
        color="var(--ds-c-blue-hyperlink-default)"
        size={{ width: 14, height: 10 }}
        styles={{
          transform: isShowDropdown && 'rotate(180deg)',
        }}
      />
    </>
  );
  const renderDropdownMenuChildren = () => {
    return (
      <>
        {RESEND_ACTIONS.map((action, index) => (
          <CustomDropdownItemStyled
            key={index}
            eventKey={index}
            onClick={index === 0 ? handleResendViaMobile : handleResendViaEmail}
          >
            <p className="action-label">{t(action.label)}</p>
            <p className="action-desc">{t(action.desc)}</p>
          </CustomDropdownItemStyled>
        ))}
      </>
    );
  };

  const getStyleDropdown = () => {
    const common = { ...styleDropdown };
    if (!isDesktop)
      return {
        minHeight: '20px',
        border: '1px solid var(--ds-c-blue-hyperlink-default)',
        ...common,
      };
    return {
      border: '1px solid var(--ds-c-blue-hyperlink-default)',
      ...common,
    };
  };
  const getStyleDropdownToggle = () => {
    const common = { textTransform: 'initial', ...styleDropdownToggle };
    if (!isDesktop)
      return {
        paddingRight: '0px',
        minHeight: '20px',
        ...common,
      };
    return {
      paddingRight: '8px',
      ...common,
    };
  };
  const getStyleDropdownMenu = () => {
    const common = { borderRadius: '8px', ...styleDropdownMenu };
    if (!isDesktop)
      return {
        transform: 'translate(-135px, 25px)',
        ...common,
      };
    return {
      transform: 'translate(-60px, 45px)',
      ...common,
    };
  };

  return (
    <ActionDropdownStyled>
      <DropdownCommon
        isShowDropdown={isDesktop && isShowDropdown}
        onToggle={handleDropdownOnToggle}
        renderDropdownToggleChildren={renderDropdownToggleChildren}
        renderDropdownMenuChildren={renderDropdownMenuChildren}
        styleDropdown={getStyleDropdown()}
        styleDropdownToggle={getStyleDropdownToggle()}
        styleDropdownMenu={getStyleDropdownMenu()}
      />
      {!isDesktop && (
        <CustomResendViaPopup
          isOpen={isShowDropdown}
          onClose={handleDropdownOnToggle}
          onResendViaEmail={onResendViaEmail}
          onResendViaMobile={onResendViaMobile}
          resendData={RESEND_ACTIONS}
        />
      )}
    </ActionDropdownStyled>
  );
};

const ActionDropdownStyled = styled.div`
  ${Fade};
`;

const ActionText = styled.p`
  ${paragraph500Mixin};
  ${fontSize14Mixin};
  font-weight: 600;
  text-transform: uppercase;
  color: var(--ds-c-blue-hyperlink-default);
`;

const CustomDropdownItemStyled = styled(DropdownItemStyled)`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: start;
  padding: 12px 10px;
  border-radius: 0 0 10px 10px;

  &:first-child {
    border-bottom: 1px solid #ececf0;
    border-radius: 10px 10px 0 0;
  }

  & p {
    ${paragraph500Mixin};
  }

  & .action-title {
  }
  & .action-desc {
    color: #7a8189;
    text-transform: initial;
    ${textEllipsisFirstLineMixin};
  }
`;

export default CustomResendViaDropdown;
